import { useFormSidebarStore } from '@centric-os/stores/form-sidebar/use-form-sidebar-store';
import { isNil } from 'lodash-es';
import { storeToRefs } from 'pinia';
import { onUnmounted, watch, type Ref } from 'vue';

export default (formSidebarName: string | string[], formSidebarVisibility: Ref<boolean>) => {
  const formSidebarStore = useFormSidebarStore();
  const { formSidebar } = storeToRefs(formSidebarStore);

  watch(formSidebar, (newValue, oldValue) => {
    if (!formSidebarVisibility.value) {
      return;
    }
    if (!isNil(oldValue)) {
      if (Array.isArray(formSidebarName)) {
        const exists = formSidebarName.find((name) => name === newValue);
        if (isNil(exists)) {
          formSidebarVisibility.value = false;
        }
      } else if (newValue !== formSidebarName) {
        formSidebarVisibility.value = false;
      }
    }
  });
  onUnmounted(() => {
    formSidebarVisibility.value = false;
  });
};
